module.exports = __webpack_public_path__ + "static/media/help.f6052c6d.svg";